import { FC } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const DropdownArrow: FC<SvgIconProps> = props => {
    return (
        <SvgIcon width="32" height="32" viewBox="0 0 32 32" fill="none" {...props}>
            <rect x="1" y="1" width="30" height="30" rx="15" stroke="#353945" strokeWidth="2" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M20.2071 13.7929C19.8166 13.4024 19.1834 13.4024 18.7929 13.7929L16 16.5858L13.2071 13.7929C12.8166 13.4024 12.1834 13.4024 11.7929 13.7929C11.4024 14.1834 11.4024 14.8166 11.7929 15.2071L15.2929 18.7071C15.6834 19.0976 16.3166 19.0976 16.7071 18.7071L20.2071 15.2071C20.5976 14.8166 20.5976 14.1834 20.2071 13.7929Z"
                fill="#777E91"
            />
        </SvgIcon>
    );
};
